import React, { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import api from '../services/api';

const ReviewRequestPage = () => {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const [request, setRequest] = useState(null);
  const [form, setForm] = useState({ authorName: '', rating: 5, title: '', body: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        if (searchParams.get('unsubscribe') === '1') {
          await api.post(`/api/review-requests/${token}/unsubscribe`);
          setMessage('You have been unsubscribed from future review requests.');
          return;
        }
        const response = await api.get(`/api/review-requests/${token}`);
        setRequest(response.data);
        setForm((current) => ({ ...current, authorName: response.data.customerName || '' }));
      } catch (requestError) {
        setError(requestError.response?.data?.error || 'This review link is unavailable.');
      } finally { setLoading(false); }
    };
    load();
  }, [token, searchParams]);

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const response = await api.post(`/api/review-requests/${token}`, form);
      setMessage(response.data.message);
      setRequest(null);
    } catch (requestError) { setError(requestError.response?.data?.error || 'Could not submit your review.'); }
    finally { setSubmitting(false); }
  };

  const shell = { maxWidth: 620, margin: '4rem auto', padding: '0 1rem', color: '#1e293b' };
  const field = { display: 'block', width: '100%', boxSizing: 'border-box', marginTop: '.35rem', padding: '.65rem', border: '1px solid #cbd5e1', borderRadius: 6, font: 'inherit' };
  if (loading) return <main style={shell}><p>Loading your review request...</p></main>;
  return <main style={shell}><Link to="/" style={{ color: '#1f6b55', fontWeight: 700, textDecoration: 'none' }}>Back to store</Link><div style={{ marginTop: '1rem', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, padding: '1.4rem' }}>{message ? <><h1 style={{ marginTop: 0 }}>Thank you</h1><p>{message}</p></> : error ? <><h1 style={{ marginTop: 0 }}>Review request unavailable</h1><p>{error}</p></> : request && <><h1 style={{ marginTop: 0 }}>How was your purchase?</h1><p style={{ color: '#64748b' }}>Share your experience with <strong>{request.product.name}</strong>. Your review will be checked by the store before it is published.</p><form onSubmit={submit}><label style={{ display: 'block', marginTop: '1rem', fontWeight: 700, fontSize: '.9rem' }}>Your name<input required value={form.authorName} onChange={(event) => setForm({ ...form, authorName: event.target.value })} style={field} /></label><label style={{ display: 'block', marginTop: '1rem', fontWeight: 700, fontSize: '.9rem' }}>Rating<select value={form.rating} onChange={(event) => setForm({ ...form, rating: Number(event.target.value) })} style={field}>{[5, 4, 3, 2, 1].map((rating) => <option key={rating} value={rating}>{rating} star{rating === 1 ? '' : 's'}</option>)}</select></label><label style={{ display: 'block', marginTop: '1rem', fontWeight: 700, fontSize: '.9rem' }}>Title <span style={{ color: '#64748b', fontWeight: 400 }}>(optional)</span><input value={form.title} maxLength="255" onChange={(event) => setForm({ ...form, title: event.target.value })} style={field} /></label><label style={{ display: 'block', marginTop: '1rem', fontWeight: 700, fontSize: '.9rem' }}>Your review<textarea required value={form.body} maxLength="5000" rows="5" onChange={(event) => setForm({ ...form, body: event.target.value })} style={field} /></label><button type="submit" disabled={submitting} style={{ marginTop: '1rem', padding: '.65rem .9rem', border: 0, borderRadius: 6, background: '#1f6b55', color: '#fff', fontWeight: 700 }}>{submitting ? 'Submitting...' : 'Submit review'}</button></form></>}</div></main>;
};

export default ReviewRequestPage;
